'use strict';

jQuery(document).ready(function() {
    debugRefreshVerification();

    initHeaderNavigation();
    setupFixedNav();
    setupHomepageFeaturedMedia();
    setupMobile();

    setupLandingPageHeader();
});

/* displays current time in console to verify last page refresh */
function debugRefreshVerification() {
    let d = new Date();
    console.info('\nPage refresh: ' + d.toLocaleTimeString());
}

function initHeaderNavigation() {
    let $topnav = jQuery('#navigation-university');

    // search slideout
    $topnav.find('li.search-icon span').click(function() {
        $topnav.find('input.search').val('').toggle('slide');
    });
}

/* Mobile scripts */
function setupMobile() {
    // mobile search
    jQuery('#navSearchBtn')
        .off()
        .click(function(e) {
            e.preventDefault();
            jQuery('#navbarSearch').slideToggle();
        });

    // footer directory
    jQuery('footer .mobile-footer-nav a.directoryToggle').off().click(function(e) {
        e.preventDefault();
        jQuery(this).toggleClass('show-directory');
        jQuery('footer .law-footer-contact').toggle();
        jQuery('footer .law-footer-directory').toggle();
    });

    // submenu
    jQuery('#submenu-mobile-container').click(function() {
        jQuery('#submenu-container').slideToggle();
        jQuery('#submenu-mobile-container span.icon').toggle();
    });
}

/* switch to fixed law nav on scrolls */
function setupFixedNav() {
    let $nav = jQuery('#law-nav');
    let navPos = $nav.position();
    let navTargetPos = navPos.top;

    jQuery(window).scroll(function() {
        if ( jQuery(document).scrollTop() > navTargetPos ) {
            $nav.addClass('float');
        } else {
            $nav.removeClass('float');
        }
    });
}

/* homepage featured video and image */
function setupHomepageFeaturedMedia() {

    // exit if there isn't a featured video or a featured image
    let $featuredVideo = $('#featured-video-container');
    let $featuredImage = $('#featured-image-container');
    if (!$featuredVideo.length && !$featuredImage.length) {
        return;
    }

    setFeaturedMediaText(); // this will also call setFeaturedMediaSize()

    jQuery(window).resize(function() {
        setFeaturedMediaSize();
    });
}

// this is the blurb that shows beneath the video area
function setFeaturedMediaText() {
    let $featuredText = $('#shortcode-featured-media-text');

    if ($featuredText.html()) {
        let $featuredMediaContainer = $('#featured-media-text-container');
        $featuredMediaContainer
            .find('.media-text-content')
            .html($featuredText.html());
        $featuredMediaContainer.show(function() {
            setFeaturedMediaSize();
        });
    } else {
        setFeaturedMediaSize();
    }
}

function setFeaturedMediaSize() {

    let $featuredVideo = $('#featured-video-container');
    let $featuredImage = $('#featured-image-container');
    let $featuredText = $('#featured-media-text-container');
    let $submenu = $('#submenu-container');

    let headerHeight = 0;
    let featuredTextHeight = 0;
    let submenuHeight = 0;

    let $nav = $('#law-nav');
    let nbPos = $nav.position();
    headerHeight = nbPos.top + $nav.outerHeight();

    if ($featuredText.length) {
        featuredTextHeight = $featuredText.outerHeight();
    }

    if ($submenu.length) {
        submenuHeight = $submenu.outerHeight();
    }

    let heightTotal = headerHeight + featuredTextHeight + submenuHeight;

    // TODO: if the video container is taller than the video, then we need to close that gap (otherwise there will be a slight gap above the submenu)

    let heightCSS = { 'max-height': `calc(100vh - ` + heightTotal + `px)` };

    $featuredVideo.css(heightCSS);
    $featuredImage.css(heightCSS);
}

function setupLandingPageHeader() {
    // exit function if we aren't using this specific template
    if (jQuery('#main [data-template=page-alpha]') == '') {
        return;
    }

    // use the browser width-based image to be the background of the landing page header
    let $img = jQuery('#lp-header img.featured-image');
    let src = $img.prop('currentSrc') || $img.prop('src');
    jQuery('#lp-header').css({backgroundImage: 'url(' + src + ')'});
    $img.remove();

    // TODO: look for shortcode content to pull into the landing page header blurb area
    let blurbText = jQuery('#shortcode-lp-header-blurb').html();
    if (blurbText != '') {
        jQuery('#lp-header .lp-header-blurb-container .blurb').html(blurbText).show();
    } else {
        console.log('no content');
    }
}